export const MAP_LOAD_GOOGLE_API = 'MAP_LOAD_GOOGLE_API'
export const MAP_GOOGLE_API_LOADED = 'MAP_GOOGLE_API_LOADED'

export const GET_USER_LOCATION = 'GET_USER_LOCATION'

export const SHOW_MAP_SEARCH_RESULTS = 'SHOW_MAP_SEARCH_RESULTS'
export const SHOW_MAP_SEARCH_FILTERS = 'SHOW_MAP_SEARCH_FILTERS'

export const SET_MAXIMUM_MAP_BOUNDS = 'SET_MAXIMUM_MAP_BOUNDS'
export const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS'
export const SET_MAP_FILTERS = 'SET_MAP_FILTERS'
export const SET_MAP_LOCATION = 'SET_MAP_LOCATION'
export const SET_MAP_ACTIVE_LOCATION = 'SET_MAP_ACTIVE_LOCATION'
export const SET_MAP_HOVERED_LOCATION = 'SET_MAP_HOVERED_LOCATION'
export const SET_MAP_ACTIVE_SEARCH_LOCATION = 'SET_MAP_ACTIVE_SEARCH_LOCATION'
export const SET_MAP_SEARCH_DATETIME = 'SET_MAP_SEARCH_DATETIME'
export const SET_MAP_SEARCH_MODE = 'SET_MAP_SEARCH_MODE'
export const SET_MAP_SEARCH_RESULTS_VIEW = 'SET_MAP_SEARCH_RESULTS_VIEW'
export const SET_MAP_ZOOM = 'SET_MAP_ZOOM'

export const FIND_MAP_LOCATIONS = 'FIND_MAP_LOCATIONS'
export const RECEIVED_MAP_RESULTS = 'RECEIVED_MAP_RESULTS'

export const TRIGGER_SEARCH = 'TRIGGER_SEARCH'

export const SET_RATES = 'SET_MAP_RATES'

export const HOURLY_RESERVATION = 'hourly'
